const fb = require('../firebase.js');
class Vente {
    constructor(id, pointRelais,panier,grammes,details, profile) {
        this.id = id
        this.pointRelais = pointRelais
        this.panier = panier
        this.grammes = grammes
        this.details = details
        this.profile = profile
        this.visible = true
    }
    async ajoutVente() {
        delete this.id
        return await fb.db.collection('ventes').add({ ...this });
    }
    async updateVente() {
        const Ventes = await fb.db.collection("ventes").doc(this.id);
        delete this.id
        return await Ventes.update({ ...this });
    }
    async deleteVente() {
        const Ventes = await fb.db.collection("ventes").doc(this.id);
        this.visible = false;
        return await Ventes.update({ ...this });
    }
}

module.exports = { Vente };